import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ExpresionesRegulares from '../../../../util/expresiones-regulares'

const TablaArtInvetarioAdicional = (props) => {
    const visibleDetails = props.details.filter(detail => !detail.IsDeleted);

    return (
        <div className={visibleDetails.length > 0 ? "" : "recipe-details-empty"}>
            <table className="table is-fullwidth is-striped">
                {visibleDetails.length > 0 &&
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Nombre</th>
                            <th>Cantidad</th>
                            <th>Unidad</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                }
                <tbody>
                    {visibleDetails.length > 0 ? props.details.map((detail, i) => {
                        if (detail.IsDeleted) return null;
                        return (
                            <tr key={i}>
                                <td>{detail.CodigoProveedor}</td>
                                <td>{detail.Nombre}</td>
                                <td>
                                    <input
                                        className="input"
                                        placeholder="Cantidad"
                                        value={detail.Cantidad}
                                        type="number"
                                        maxLength="5"
                                        step=".1"
                                        max="999"
                                        onKeyPress={(event) => {
                                            const keyCode = event.keyCode || event.which;
                                            const keyValue = String.fromCharCode(keyCode);
                                            if (ExpresionesRegulares.ErrorInputNumDecimal.test(keyValue) || event.target.value.length >= event.target.getAttribute('maxLength'))
                                                event.preventDefault();
                                        }}
                                        onChange={(e) => props.quantityChanged(e.currentTarget.value, i)}
                                    />
                                </td>
                                <td>{detail.NombreUnidadVenta}</td>
                                <td>
                                    <a className="button tableAction is-danger tooltip"
                                        data-tooltip="Eliminar"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            props.removeItem(i)
                                        }}>
                                        <span className="icon">
                                            <i className="fa fa-trash" />
                                        </span>
                                    </a>
                                </td>
                            </tr>
                        )
                    }) : <tr>
                            <td>No hay artículos inventario.</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

TablaArtInvetarioAdicional.propTypes = {
    details: PropTypes.array.isRequired,
    quantityChanged: PropTypes.func.isRequired,
    removeItem: PropTypes.func.isRequired,
}

TablaArtInvetarioAdicional.defaultProps = {
    details: [],
    quantityChanged: () => { },
    removeItem: () => { },
}

export default TablaArtInvetarioAdicional;